export const bibleBooks = {
  en: {
    // Old Testament (39 books)
    genesis: 'Genesis',
    exodus: 'Exodus',
    leviticus: 'Leviticus',
    numbers: 'Numbers',
    deuteronomy: 'Deuteronomy',
    joshua: 'Joshua',
    judges: 'Judges',
    ruth: 'Ruth',
    '1_samuel': '1 Samuel',
    '2_samuel': '2 Samuel',
    '1_kings': '1 Kings',
    '2_kings': '2 Kings',
    '1_chronicles': '1 Chronicles',
    '2_chronicles': '2 Chronicles',
    ezra: 'Ezra',
    nehemiah: 'Nehemiah',
    esther: 'Esther',
    job: 'Job',
    psalms: 'Psalms',
    proverbs: 'Proverbs',
    ecclesiastes: 'Ecclesiastes',
    song_of_solomon: 'Song of Solomon',
    isaiah: 'Isaiah',
    jeremiah: 'Jeremiah',
    lamentations: 'Lamentations',
    ezekiel: 'Ezekiel',
    daniel: 'Daniel',
    hosea: 'Hosea',
    joel: 'Joel',
    amos: 'Amos',
    obadiah: 'Obadiah',
    jonah: 'Jonah',
    micah: 'Micah',
    nahum: 'Nahum',
    habakkuk: 'Habakkuk',
    zephaniah: 'Zephaniah',
    haggai: 'Haggai',
    zechariah: 'Zechariah',
    malachi: 'Malachi',
    
    // New Testament (27 books)
    matthew: 'Matthew',
    mark: 'Mark',
    luke: 'Luke',
    john: 'John',
    acts: 'Acts',
    romans: 'Romans',
    '1_corinthians': '1 Corinthians',
    '2_corinthians': '2 Corinthians',
    galatians: 'Galatians',
    ephesians: 'Ephesians',
    philippians: 'Philippians',
    colossians: 'Colossians',
    '1_thessalonians': '1 Thessalonians',
    '2_thessalonians': '2 Thessalonians',
    '1_timothy': '1 Timothy',
    '2_timothy': '2 Timothy',
    titus: 'Titus',
    philemon: 'Philemon',
    hebrews: 'Hebrews',
    james: 'James',
    '1_peter': '1 Peter',
    '2_peter': '2 Peter',
    '1_john': '1 John',
    '2_john': '2 John',
    '3_john': '3 John',
    jude: 'Jude',
    revelation: 'Revelation'
  },
  
  fr: {
    // Old Testament (39 books)
    genesis: 'Genèse',
    exodus: 'Exode',
    leviticus: 'Lévitique',
    numbers: 'Nombres',
    deuteronomy: 'Deutéronome',
    joshua: 'Josué',
    judges: 'Juges',
    ruth: 'Ruth',
    '1_samuel': '1 Samuel',
    '2_samuel': '2 Samuel',
    '1_kings': '1 Rois',
    '2_kings': '2 Rois',
    '1_chronicles': '1 Chroniques',
    '2_chronicles': '2 Chroniques',
    ezra: 'Esdras',
    nehemiah: 'Néhémie',
    esther: 'Esther',
    job: 'Job',
    psalms: 'Psaumes',
    proverbs: 'Proverbes',
    ecclesiastes: 'Ecclésiaste',
    song_of_solomon: 'Cantique des Cantiques',
    isaiah: 'Ésaïe',
    jeremiah: 'Jérémie',
    lamentations: 'Lamentations',
    ezekiel: 'Ézéchiel',
    daniel: 'Daniel',
    hosea: 'Osée',
    joel: 'Joël',
    amos: 'Amos',
    obadiah: 'Abdias',
    jonah: 'Jonas',
    micah: 'Michée',
    nahum: 'Nahum',
    habakkuk: 'Habacuc',
    zephaniah: 'Sophonie',
    haggai: 'Aggée',
    zechariah: 'Zacharie',
    malachi: 'Malachie',
    
    // New Testament (27 books)
    matthew: 'Matthieu',
    mark: 'Marc',
    luke: 'Luc',
    john: 'Jean',
    acts: 'Actes',
    romans: 'Romains',
    '1_corinthians': '1 Corinthiens',
    '2_corinthians': '2 Corinthiens',
    galatians: 'Galates',
    ephesians: 'Éphésiens',
    philippians: 'Philippiens',
    colossians: 'Colossiens',
    '1_thessalonians': '1 Thessaloniciens',
    '2_thessalonians': '2 Thessaloniciens',
    '1_timothy': '1 Timothée',
    '2_timothy': '2 Timothée',
    titus: 'Tite',
    philemon: 'Philémon',
    hebrews: 'Hébreux',
    james: 'Jacques',
    '1_peter': '1 Pierre',
    '2_peter': '2 Pierre',
    '1_john': '1 Jean',
    '2_john': '2 Jean',
    '3_john': '3 Jean',
    jude: 'Jude',
    revelation: 'Apocalypse'
  },
  
  es: {
    // Old Testament (39 books)
    genesis: 'Génesis',
    exodus: 'Éxodo',
    leviticus: 'Levítico',
    numbers: 'Números',
    deuteronomy: 'Deuteronomio',
    joshua: 'Josué',
    judges: 'Jueces',
    ruth: 'Rut',
    '1_samuel': '1 Samuel',
    '2_samuel': '2 Samuel',
    '1_kings': '1 Reyes',
    '2_kings': '2 Reyes',
    '1_chronicles': '1 Crónicas',
    '2_chronicles': '2 Crónicas',
    ezra: 'Esdras',
    nehemiah: 'Nehemías',
    esther: 'Ester',
    job: 'Job',
    psalms: 'Salmos',
    proverbs: 'Proverbios',
    ecclesiastes: 'Eclesiastés',
    song_of_solomon: 'Cantar de los Cantares',
    isaiah: 'Isaías',
    jeremiah: 'Jeremías',
    lamentations: 'Lamentaciones',
    ezekiel: 'Ezequiel',
    daniel: 'Daniel',
    hosea: 'Oseas',
    joel: 'Joel',
    amos: 'Amós',
    obadiah: 'Abdías',
    jonah: 'Jonás',
    micah: 'Miqueas',
    nahum: 'Nahúm',
    habakkuk: 'Habacuc',
    zephaniah: 'Sofonías',
    haggai: 'Hageo',
    zechariah: 'Zacarías',
    malachi: 'Malaquías',
    
    // New Testament (27 books)
    matthew: 'Mateo',
    mark: 'Marcos',
    luke: 'Lucas',
    john: 'Juan',
    acts: 'Hechos',
    romans: 'Romanos',
    '1_corinthians': '1 Corintios',
    '2_corinthians': '2 Corintios',
    galatians: 'Gálatas',
    ephesians: 'Efesios',
    philippians: 'Filipenses',
    colossians: 'Colosenses',
    '1_thessalonians': '1 Tesalonicenses',
    '2_thessalonians': '2 Tesalonicenses',
    '1_timothy': '1 Timoteo',
    '2_timothy': '2 Timoteo',
    titus: 'Tito',
    philemon: 'Filemón',
    hebrews: 'Hebreos',
    james: 'Santiago',
    '1_peter': '1 Pedro',
    '2_peter': '2 Pedro',
    '1_john': '1 Juan',
    '2_john': '2 Juan',
    '3_john': '3 Juan',
    jude: 'Judas',
    revelation: 'Apocalipsis'
  },
  
  de: {
    // Old Testament (39 books) - German
    genesis: '1. Mose',
    exodus: '2. Mose',
    leviticus: '3. Mose',
    numbers: '4. Mose',
    deuteronomy: '5. Mose',
    joshua: 'Josua',
    judges: 'Richter',
    ruth: 'Rut',
    '1_samuel': '1. Samuel',
    '2_samuel': '2. Samuel',
    '1_kings': '1. Könige',
    '2_kings': '2. Könige',
    '1_chronicles': '1. Chronik',
    '2_chronicles': '2. Chronik',
    ezra: 'Esra',
    nehemiah: 'Nehemia',
    esther: 'Ester',
    job: 'Hiob',
    psalms: 'Psalmen',
    proverbs: 'Sprüche',
    ecclesiastes: 'Prediger',
    song_of_solomon: 'Hohelied',
    isaiah: 'Jesaja',
    jeremiah: 'Jeremia',
    lamentations: 'Klagelieder',
    ezekiel: 'Hesekiel',
    daniel: 'Daniel',
    hosea: 'Hosea',
    joel: 'Joel',
    amos: 'Amos',
    obadiah: 'Obadja',
    jonah: 'Jona',
    micah: 'Micha',
    nahum: 'Nahum',
    habakkuk: 'Habakuk',
    zephaniah: 'Zefanja',
    haggai: 'Haggai',
    zechariah: 'Sacharja',
    malachi: 'Maleachi',
    
    // New Testament (27 books) - German
    matthew: 'Matthäus',
    mark: 'Markus',
    luke: 'Lukas',
    john: 'Johannes',
    acts: 'Apostelgeschichte',
    romans: 'Römer',
    '1_corinthians': '1. Korinther',
    '2_corinthians': '2. Korinther',
    galatians: 'Galater',
    ephesians: 'Epheser',
    philippians: 'Philipper',
    colossians: 'Kolosser',
    '1_thessalonians': '1. Thessalonicher',
    '2_thessalonians': '2. Thessalonicher',
    '1_timothy': '1. Timotheus',
    '2_timothy': '2. Timotheus',
    titus: 'Titus',
    philemon: 'Philemon',
    hebrews: 'Hebräer',
    james: 'Jakobus',
    '1_peter': '1. Petrus',
    '2_peter': '2. Petrus',
    '1_john': '1. Johannes',
    '2_john': '2. Johannes',
    '3_john': '3. Johannes',
    jude: 'Judas',
    revelation: 'Offenbarung'
  },
  
  pt: {
    // Old Testament (39 books) - Portuguese
    genesis: 'Gênesis',
    exodus: 'Êxodo',
    leviticus: 'Levítico',
    numbers: 'Números',
    deuteronomy: 'Deuteronômio',
    joshua: 'Josué',
    judges: 'Juízes',
    ruth: 'Rute',
    '1_samuel': '1 Samuel',
    '2_samuel': '2 Samuel',
    '1_kings': '1 Reis',
    '2_kings': '2 Reis',
    '1_chronicles': '1 Crônicas',
    '2_chronicles': '2 Crônicas',
    ezra: 'Esdras',
    nehemiah: 'Neemias',
    esther: 'Ester',
    job: 'Jó',
    psalms: 'Salmos',
    proverbs: 'Provérbios',
    ecclesiastes: 'Eclesiastes',
    song_of_solomon: 'Cânticos',
    isaiah: 'Isaías',
    jeremiah: 'Jeremias',
    lamentations: 'Lamentações',
    ezekiel: 'Ezequiel',
    daniel: 'Daniel',
    hosea: 'Oséias',
    joel: 'Joel',
    amos: 'Amós',
    obadiah: 'Obadias',
    jonah: 'Jonas',
    micah: 'Miquéias',
    nahum: 'Naum',
    habakkuk: 'Habacuque',
    zephaniah: 'Sofonias',
    haggai: 'Ageu',
    zechariah: 'Zacarias',
    malachi: 'Malaquias',
    
    // New Testament (27 books) - Portuguese
    matthew: 'Mateus',
    mark: 'Marcos',
    luke: 'Lucas',
    john: 'João',
    acts: 'Atos',
    romans: 'Romanos',
    '1_corinthians': '1 Coríntios',
    '2_corinthians': '2 Coríntios',
    galatians: 'Gálatas',
    ephesians: 'Efésios',
    philippians: 'Filipenses',
    colossians: 'Colossenses',
    '1_thessalonians': '1 Tessalonicenses',
    '2_thessalonians': '2 Tessalonicenses',
    '1_timothy': '1 Timóteo',
    '2_timothy': '2 Timóteo',
    titus: 'Tito',
    philemon: 'Filémon',
    hebrews: 'Hebreus',
    james: 'Tiago',
    '1_peter': '1 Pedro',
    '2_peter': '2 Pedro',
    '1_john': '1 João',
    '2_john': '2 João',
    '3_john': '3 João',
    jude: 'Judas',
    revelation: 'Apocalipse'
  },
  
  ru: {
    // Old Testament (39 books) - Russian
    genesis: 'Бытие',
    exodus: 'Исход',
    leviticus: 'Левит',
    numbers: 'Числа',
    deuteronomy: 'Второзаконие',
    joshua: 'Иисус Навин',
    judges: 'Судьи',
    ruth: 'Руфь',
    '1_samuel': '1 Царств',
    '2_samuel': '2 Царств',
    '1_kings': '3 Царств',
    '2_kings': '4 Царств',
    '1_chronicles': '1 Паралипоменон',
    '2_chronicles': '2 Паралипоменон',
    ezra: 'Ездра',
    nehemiah: 'Неемия',
    esther: 'Есфирь',
    job: 'Иов',
    psalms: 'Псалтирь',
    proverbs: 'Притчи',
    ecclesiastes: 'Екклесиаст',
    song_of_solomon: 'Песнь Песней',
    isaiah: 'Исаия',
    jeremiah: 'Иеремия',
    lamentations: 'Плач Иеремии',
    ezekiel: 'Иезекииль',
    daniel: 'Даниил',
    hosea: 'Осия',
    joel: 'Иоиль',
    amos: 'Амос',
    obadiah: 'Авдий',
    jonah: 'Иона',
    micah: 'Михей',
    nahum: 'Наум',
    habakkuk: 'Аввакум',
    zephaniah: 'Софония',
    haggai: 'Аггей',
    zechariah: 'Захария',
    malachi: 'Малахия',
    
    // New Testament (27 books) - Russian
    matthew: 'Матфей',
    mark: 'Марк',
    luke: 'Лука',
    john: 'Иоанн',
    acts: 'Деяния',
    romans: 'Римлянам',
    '1_corinthians': '1 Коринфянам',
    '2_corinthians': '2 Коринфянам',
    galatians: 'Галатам',
    ephesians: 'Ефесянам',
    philippians: 'Филиппийцам',
    colossians: 'Колоссянам',
    '1_thessalonians': '1 Фессалоникийцам',
    '2_thessalonians': '2 Фессалоникийцам',
    '1_timothy': '1 Тимофею',
    '2_timothy': '2 Тимофею',
    titus: 'Титу',
    philemon: 'Филимону',
    hebrews: 'Евреям',
    james: 'Иакова',
    '1_peter': '1 Петра',
    '2_peter': '2 Петра',
    '1_john': '1 Иоанна',
    '2_john': '2 Иоанна',
    '3_john': '3 Иоанна',
    jude: 'Иуды',
    revelation: 'Откровение'
  },
  
  tl: {
    // Old Testament (39 books) - Filipino/Tagalog
    genesis: 'Genesis',
    exodus: 'Exodo',
    leviticus: 'Levitico',
    numbers: 'Mga Bilang',
    deuteronomy: 'Deuteronomio',
    joshua: 'Josue',
    judges: 'Mga Hukom',
    ruth: 'Ruth',
    '1_samuel': '1 Samuel',
    '2_samuel': '2 Samuel',
    '1_kings': '1 Mga Hari',
    '2_kings': '2 Mga Hari',
    '1_chronicles': '1 Mga Cronica',
    '2_chronicles': '2 Mga Cronica',
    ezra: 'Ezra',
    nehemiah: 'Nehemias',
    esther: 'Esther',
    job: 'Job',
    psalms: 'Mga Awit',
    proverbs: 'Mga Kawikaan',
    ecclesiastes: 'Eclesiastes',
    song_of_solomon: 'Awit ni Solomon',
    isaiah: 'Isaias',
    jeremiah: 'Jeremias',
    lamentations: 'Mga Panaghoy',
    ezekiel: 'Ezequiel',
    daniel: 'Daniel',
    hosea: 'Oseas',
    joel: 'Joel',
    amos: 'Amos',
    obadiah: 'Obadias',
    jonah: 'Jonas',
    micah: 'Micas',
    nahum: 'Nahum',
    habakkuk: 'Habacuc',
    zephaniah: 'Sofonias',
    haggai: 'Hageo',
    zechariah: 'Zacarias',
    malachi: 'Malaquias',
    
    // New Testament (27 books) - Filipino/Tagalog
    matthew: 'Mateo',
    mark: 'Marcos',
    luke: 'Lucas',
    john: 'Juan',
    acts: 'Mga Gawa',
    romans: 'Mga Romano',
    '1_corinthians': '1 Mga Corinto',
    '2_corinthians': '2 Mga Corinto',
    galatians: 'Mga Galacia',
    ephesians: 'Mga Efeso',
    philippians: 'Mga Filipos',
    colossians: 'Mga Colosas',
    '1_thessalonians': '1 Mga Tesalonica',
    '2_thessalonians': '2 Mga Tesalonica',
    '1_timothy': '1 Timoteo',
    '2_timothy': '2 Timoteo',
    titus: 'Tito',
    philemon: 'Filemon',
    hebrews: 'Mga Hebreo',
    james: 'Santiago',
    '1_peter': '1 Pedro',
    '2_peter': '2 Pedro',
    '1_john': '1 Juan',
    '2_john': '2 Juan',
    '3_john': '3 Juan',
    jude: 'Judas',
    revelation: 'Pahayag'
  },
  
  it: {
    // Old Testament (39 books) - Italian
    genesis: 'Genesi',
    exodus: 'Esodo',
    leviticus: 'Levitico',
    numbers: 'Numeri',
    deuteronomy: 'Deuteronomio',
    joshua: 'Giosuè',
    judges: 'Giudici',
    ruth: 'Ruth',
    '1_samuel': '1 Samuele',
    '2_samuel': '2 Samuele',
    '1_kings': '1 Re',
    '2_kings': '2 Re',
    '1_chronicles': '1 Cronache',
    '2_chronicles': '2 Cronache',
    ezra: 'Esdra',
    nehemiah: 'Neemia',
    esther: 'Ester',
    job: 'Giobbe',
    psalms: 'Salmi',
    proverbs: 'Proverbi',
    ecclesiastes: 'Ecclesiaste',
    song_of_solomon: 'Cantico dei Cantici',
    isaiah: 'Isaia',
    jeremiah: 'Geremia',
    lamentations: 'Lamentazioni',
    ezekiel: 'Ezechiele',
    daniel: 'Daniele',
    hosea: 'Osea',
    joel: 'Gioele',
    amos: 'Amos',
    obadiah: 'Abdia',
    jonah: 'Giona',
    micah: 'Michea',
    nahum: 'Naum',
    habakkuk: 'Abacuc',
    zephaniah: 'Sofonia',
    haggai: 'Aggeo',
    zechariah: 'Zaccaria',
    malachi: 'Malachia',
    
    // New Testament (27 books) - Italian
    matthew: 'Matteo',
    mark: 'Marco',
    luke: 'Luca',
    john: 'Giovanni',
    acts: 'Atti',
    romans: 'Romani',
    '1_corinthians': '1 Corinzi',
    '2_corinthians': '2 Corinzi',
    galatians: 'Galati',
    ephesians: 'Efesini',
    philippians: 'Filippesi',
    colossians: 'Colossesi',
    '1_thessalonians': '1 Tessalonicesi',
    '2_thessalonians': '2 Tessalonicesi',
    '1_timothy': '1 Timoteo',
    '2_timothy': '2 Timoteo',
    titus: 'Tito',
    philemon: 'Filemone',
    hebrews: 'Ebrei',
    james: 'Giacomo',
    '1_peter': '1 Pietro',
    '2_peter': '2 Pietro',
    '1_john': '1 Giovanni',
    '2_john': '2 Giovanni',
    '3_john': '3 Giovanni',
    jude: 'Giuda',
    revelation: 'Apocalisse'
  },
  
  am: {
    // Old Testament (39 books) - Amharic
    genesis: 'ዘፍጥረት',
    exodus: 'ዘጸአት',
    leviticus: 'ዘሌዋውያን',
    numbers: 'ዘኍልቈ',
    deuteronomy: 'ዘተላውያን',
    joshua: 'ኢያሱ',
    judges: 'ዘመሣፍንት',
    ruth: 'ሩት',
    '1_samuel': '1 ሳሙኤል',
    '2_samuel': '2 ሳሙኤል',
    '1_kings': '1 ነገሥት',
    '2_kings': '2 ነገሥት',
    '1_chronicles': '1 ዜና',
    '2_chronicles': '2 ዜና',
    ezra: 'ዕዝራ',
    nehemiah: 'ነህምያ',
    esther: 'እስቲር',
    job: 'ኢዮብ',
    psalms: 'መዝሙር',
    proverbs: 'ምሳሌ',
    ecclesiastes: 'ዘተዋሕዶ',
    song_of_solomon: 'ኃሤተ፡ኃሤት',
    isaiah: 'ኢሳይያስ',
    jeremiah: 'ኤርምያስ',
    lamentations: 'ሰቆቃው',
    ezekiel: 'ሕዝቅኤል',
    daniel: 'ዳንኤል',
    hosea: 'ሆሴዕ',
    joel: 'ኢዮኤል',
    amos: 'አሞስ',
    obadiah: 'አብድዩ',
    jonah: 'ዮናስ',
    micah: 'ሚክያስ',
    nahum: 'ናሆም',
    habakkuk: 'ሐበቁቅ',
    zephaniah: 'ሶፎንያስ',
    haggai: 'ሐጌ',
    zechariah: 'ዘካርያስ',
    malachi: 'ማልአኪ',
    
    // New Testament (27 books) - Amharic
    matthew: 'ማቴዎስ',
    mark: 'ማርቆስ',
    luke: 'ሉቃስ',
    john: 'ዮሐንስ',
    acts: 'ሥራ',
    romans: 'ሮሜ',
    '1_corinthians': '1 ቆሮንቶስ',
    '2_corinthians': '2 ቆሮንቶስ',
    galatians: 'ገላትያ',
    ephesians: 'ኤፌሶን',
    philippians: 'ፊልጵስዩስ',
    colossians: 'ቆላስያስ',
    '1_thessalonians': '1 ተሰሎንቄ',
    '2_thessalonians': '2 ተሰሎንቄ',
    '1_timothy': '1 ጢሞቴዎስ',
    '2_timothy': '2 ጢሞቴዎስ',
    titus: 'ቲቶ',
    philemon: 'ፊልሞና',
    hebrews: 'ዕብራውያን',
    james: 'ያዕቆብ',
    '1_peter': '1 ጴጥሮስ',
    '2_peter': '2 ጴጥሮስ',
    '1_john': '1 ዮሐንስ',
    '2_john': '2 ዮሐንስ',
    '3_john': '3 ዮሐንስ',
    jude: 'ይሁዳ',
    revelation: 'ራእይ'
  },
  
  ko: {
    // Old Testament (39 books) - Korean
    genesis: '창세기',
    exodus: '출애굽기',
    leviticus: '레위기',
    numbers: '민수기',
    deuteronomy: '신명기',
    joshua: '여호수아',
    judges: '사사기',
    ruth: '룻기',
    '1_samuel': '사무엘상',
    '2_samuel': '사무엘하',
    '1_kings': '열왕기상',
    '2_kings': '열왕기하',
    '1_chronicles': '역대상',
    '2_chronicles': '역대하',
    ezra: '에스라',
    nehemiah: '느헤미야',
    esther: '에스더',
    job: '욥기',
    psalms: '시편',
    proverbs: '잠언',
    ecclesiastes: '전도서',
    song_of_solomon: '아가',
    isaiah: '이사야',
    jeremiah: '예레미야',
    lamentations: '예레미야애가',
    ezekiel: '에스겔',
    daniel: '다니엘',
    hosea: '호세아',
    joel: '요엘',
    amos: '아모스',
    obadiah: '오바댜',
    jonah: '요나',
    micah: '미가',
    nahum: '나훔',
    habakkuk: '하박국',
    zephaniah: '스바냐',
    haggai: '학개',
    zechariah: '스가랴',
    malachi: '말라기',
    
    // New Testament (27 books) - Korean
    matthew: '마태복음',
    mark: '마가복음',
    luke: '누가복음',
    john: '요한복음',
    acts: '사도행전',
    romans: '로마서',
    '1_corinthians': '고린도전서',
    '2_corinthians': '고린도후서',
    galatians: '갈라디아서',
    ephesians: '에베소서',
    philippians: '빌립보서',
    colossians: '골로새서',
    '1_thessalonians': '데살로니가전서',
    '2_thessalonians': '데살로니가후서',
    '1_timothy': '디모데전서',
    '2_timothy': '디모데후서',
    titus: '디도서',
    philemon: '빌레몬서',
    hebrews: '히브리서',
    james: '야고보서',
    '1_peter': '베드로전서',
    '2_peter': '베드로후서',
    '1_john': '요한일서',
    '2_john': '요한이서',
    '3_john': '요한삼서',
    jude: '유다서',
    revelation: '요한계시록'
  }
};